import { observer } from 'mobx-react-lite';
import { useStoreContext } from 'store/app';
import { useTranslationsContext } from 'store/translations';
import { Modal, ModalProps } from '../modal';
import './winnersModal.styl';
import { IPrizeItemConfig, prizes } from './config';
import { sanitize } from 'dompurify';
import { ITicket } from 'src/types';
import classNames from 'classnames';

interface WinnersModalProps extends ModalProps {
    myTicket?: ITicket;
}

const bubbles = ['#F2DCE1', '#D8E5F4', '#D6E9D8', '#EADEF3', '#D0EAE3', '#EEE1CD'];

export const WinnersModal = observer(({ myTicket, ...props }: WinnersModalProps) => {
    const { translate } = useTranslationsContext();
    const { settings } = useStoreContext();

    const prizesConfig = prizes.reduce((acc, prizeBlock) => {
        prizeBlock.items.forEach((x) => (acc[x.id] = x));
        return acc;
    }, {} as Record<string, IPrizeItemConfig>);

    prizesConfig.superprize = {
        count: 8,
        id: 'superprize',
        imageUrl: 'string',
        itemNameKey: '100&nbsp;000&nbsp;₽'
    };

    return (
        <>
            <Modal title={translate('winners.title')} className="winners" {...props}>
                <div className="winners-modal">
                    {settings.winnersConf
                        ? Object.keys(settings.winnersConf).map((groupKey, index) => {
                              const config = settings.winnersConf![groupKey];
                              const prize = prizesConfig[groupKey]!;
                              return prize ? (
                                  <div className="winners-modal-block" key={groupKey}>
                                      <div
                                          className="winners-modal-block-title"
                                          dangerouslySetInnerHTML={{ __html: sanitize(translate(prize.itemNameKey)) }}
                                      ></div>
                                      <div className="winners-modal-block-tickets">
                                          {config.ticketIds.map((id) => (
                                              <div
                                                  className={classNames('winners-modal-block-ticket', {
                                                      active: myTicket && myTicket.ticket_id === id
                                                  })}
                                                  style={{ backgroundColor: bubbles[index % 6] }}
                                                  key={id}
                                              >
                                                  {id}
                                              </div>
                                          ))}
                                      </div>
                                  </div>
                              ) : null;
                          })
                        : null}
                </div>
            </Modal>
        </>
    );
});
